<template>
  <modal titulo="Odin - Editar Resumo" id="odin-resumo-anexo" :fechar="true" @close="close" >
    <template #default>
      <div class="row gutters-xs ato">
        <v-input
          class="col-12"
          type="classic-editor"
          v-model="form.texto"
        />
      </div>
    </template>

    <template #footer>
      <button
        class="btn btn-outline-secondary mr-auto"
        type="button"
        @click.prevent="close(false)"
      >
        Cancelar
      </button>
      <v-button
        class="btn-outline-primary"
        :run="salvar"
        :popover="true"
      >
        Salvar
      </v-button>
    </template>
  </modal>
</template>

<script setup>

import { reactive } from 'vue';
import Modal from '@/components/Modal.vue';
import FrontBusiness from "@/business/FrontBusiness";
import { api } from "@/plugins/Axios";

const props = defineProps({
  texto: String,
  referencia: String
});

const form = reactive({
  texto: props.texto,
})

const close = (retorno) => {
  FrontBusiness.closeModal(retorno);
}

const salvar = async () => {
  const resposta = await api.post(`api/anexo/${props.referencia}/texto-ocr`, { value: form.texto })
    .catch(e => {
      FrontBusiness.showError('', e.message);
      return null;
    });

  if (resposta) {
    FrontBusiness.showSuccess('', 'Texto salvo com sucesso');
    close(true);
  }
}

</script>
